import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Leaderboard from '../../components/Leaderboard/';
import {Wrapper, ErrorPage} from '../../components/common';
import {fetchLeaderboard} from '../../actions/leaders';
import {setSidebarStatus, setHelpStatus} from '../../actions/user';
import {appId} from '../../store';
import {LIST_PAGE_SIZE} from '../../configs/constants';

class LeaderboardContainer extends Component {
  static propTypes = {
    onFetchLeaderboard: PropTypes.func.isRequired,
    leaders: PropTypes.shape({}).isRequired,
    error: PropTypes.shape({}).isRequired,
    application: PropTypes.shape({
      details: PropTypes.shape({
        leaderboard: PropTypes.bool,
      }),
    }).isRequired,
    sidebarToggle: PropTypes.func.isRequired,
  };

  onFetchPlayerForLeaderboard = (params) => {
    const {
      onFetchLeaderboard,
      leaders: {
        hasMore,
        isLeadersListFetching,
        page: currentPage,
      },
    } = this.props;
    const {resetPage = false} = params;
    const page = resetPage ? 1 : currentPage;
    if (!isLeadersListFetching && (resetPage || hasMore)) {
      onFetchLeaderboard({
        appId,
        page,
        size: LIST_PAGE_SIZE,
      });
    }
  };

  render() {
    const {
      application: {details: {leaderboard: isLeaderboardAvaible, id: gameId}},
      leaders: {isLeadersListFetchingError: {error}},
    } = this.props;

    if (!gameId) {
      return null;
    }

    return (
      <Wrapper {...this.props}>
        <div className="cell cell_full">
          {error || !isLeaderboardAvaible ?
            <ErrorPage message={error}/> :
            <Leaderboard
              onFetchPlayersForLeaderboard={this.onFetchPlayerForLeaderboard}
              {...this.props}
            />
          }
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({
  application,
  leaders,
  error,
  user,
}) => ({
  application,
  leaders,
  error,
  user,
});

const bindActions = dispatch => (
  {
    onFetchLeaderboard: params => dispatch(fetchLeaderboard(params)),
    sidebarToggle: params => dispatch(setSidebarStatus(params)),
    helpToggle: params => dispatch(setHelpStatus(params)),
    dispatch,
  }
);

export default connect(mapStateToProps, bindActions)(LeaderboardContainer);
